import Timeline from 'antd/lib/timeline'

import 'antd/lib/timeline/style'

export * from 'antd/lib/timeline'

export default Timeline
